
define('template!configPrintAreaItemTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (advancedMode) { ;
__p += '\n  <img class="config-printarea-thumb js-config-printarea-thumb" data-pa-id="' +
((__t = ( id )) == null ? '' : __t) +
'" src="" alt=""/>\n';
 } ;
__p += '\n<label class="config-option-label">\n  ' +
((__t = ( code )) == null ? '' : __t) +
' - ' +
((__t = ( name )) == null ? '' : __t) +
' (' +
((__t = ( width )) == null ? '' : __t) +
'x' +
((__t = ( height )) == null ? '' : __t) +
'mm)\n</label>\n<div class="dropdown config-option-dropdown">\n  <button class="config-dropdown-btn dropdown-toggle" type="button"\n          id="dropdownMenu-pz"\n          data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">\n    <span class="dropdown__label printzone-label">None</span>\n    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="dropdown-chevron"><polyline points="6 9 12 15 18 9"></polyline></svg>\n  </button>\n  <ul class="dropdown-menu dropdown-menu-printzone dropdown-menu-option" role="menu"\n      aria-labelledby="dropdownMenu-pz">\n    <li role="presentation"><a role="menuitem" data-index="" data-pz-id="-1" href="#">None</a>\n    </li>\n    ';
 for (var j = 0 ; j < printZones.length ; j++) { ;
__p += '\n    ';
 var pz = printZones[j]; ;
__p += '\n    ';
 if (pz.colorModeType === 'spot') { ;
__p += '\n    ';
 for (var k = 1 ; k <= pz.maxColors ; k ++) { ;
__p += '\n    <li role="presentation"><a role="menuitem" data-index=""\n                               data-nb-color="' +
((__t = ( k )) == null ? '' : __t) +
'"\n                               data-pz-id="' +
((__t = ( pz.id )) == null ? '' : __t) +
'"\n                               href="#">\n      ';
 if (advancedMode) { ;
__p += '\n        <img class="config-pz-thumb js-config-pz-thumb" data-pz-id="' +
((__t = ( pz.id )) == null ? '' : __t) +
'" src="" alt=""/>\n      ';
 } ;
__p += '\n      <span class="config-pz-label">' +
((__t = ( pz.imppCode )) == null ? '' : __t) +
' ' +
((__t = ( pz.name )) == null ? '' : __t) +
' (' +
((__t = ( k )) == null ? '' : __t) +
') (' +
((__t = ( pz.width )) == null ? '' : __t) +
'x' +
((__t = ( pz.height )) == null ? '' : __t) +
'mm) (' +
((__t = ( _.i18n('printZone.printedBy') + ' ' + pz.printerName )) == null ? '' : __t) +
')</span>\n    </a></li>\n    ';
 } ;
__p += '\n    ';
 } else { ;
__p += '\n    <li role="presentation"><a role="menuitem" data-index=""\n                               data-nb-color="1"\n                               data-pz-id="' +
((__t = ( pz.id )) == null ? '' : __t) +
'"\n                               href="#">\n      ';
 if (advancedMode) { ;
__p += '\n        <img class="config-pz-thumb js-config-pz-thumb" data-pz-id="' +
((__t = ( pz.id )) == null ? '' : __t) +
'" src="" alt=""/>\n      ';
 } ;
__p += '\n      <span class="config-pz-label">' +
((__t = ( pz.imppCode )) == null ? '' : __t) +
' ' +
((__t = ( pz.name )) == null ? '' : __t) +
' (' +
((__t = ( pz.width )) == null ? '' : __t) +
'x' +
((__t = ( pz.height )) == null ? '' : __t) +
'mm) (' +
((__t = ( _.i18n('printZone.printedBy') + ' ' + pz.printerName )) == null ? '' : __t) +
')</span>\n    </a></li>\n    ';
 } ;
__p += '\n    ';
 } ;
__p += '\n  </ul>\n</div>\n<div class="printarea-image-container">\n  <div class="image-ctn">\n    <img class="image-selected" src=""/>\n    <div class="delete-button">\n      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>\n    </div>\n  </div>\n</div>\n<div class="upload-image-block" style="display: none;">\n  <div class="image-holder js-image-holder pgallery_item upload-image-button">\n    <input id="browseAttachFile" multiple type="file" name="filename" accept=".ai,.pdf,.eps,image/*"\n           class="hidden attach-input js-change-logo"/>\n    <div class="bootstrap-filestyle">\n      <label class="js-logo-holder">\n        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>\n      </label>\n    </div>\n  </div>\n</div>';

}
return __p
};});

